<template>
  <v-menu
    :close-on-content-click="closeOnClick"
    :max-width="maxWidth"
    :min-width="minWidth"
    :offset-x="offsetX"
    :offset-y="offsetY"
    :transition="transition"
    v-model="show"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :append-outer-icon="searchIcon && value ? 'mdi-magnify' : null"
        :clearable="clearable"
        :color="color"
        :dense="dense"
        :disabled="disabled"
        :error-messages="errorMessages"
        :hide-details="hideDetails"
        :label="label"
        :placeholder="placeholder"
        :value="FormatDatePrt(value)"
        @blur="$emit('blur', $event)"
        @click:append-outer="SearchFtn"
        @click:clear="$emit('click:clear', $event), HandlerInputFtn(null)"
        append-icon="mdi-calendar"
        outlined
        readonly
        class="rounded-xl"
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <v-date-picker
      :max="max"
      :min="min"
      :value="value"
      @input="HandlerInputFtn"
      color="bluePrimary"
      no-title
      scrollable
    />
  </v-menu>
</template>

<script>
export default {
  name: "AppDateInput",

  props: {
    closeOnClick: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: String,
      default: "290px",
    },
    minWidth: {
      type: String,
      default: "auto",
    },
    offsetY: {
      type: Boolean,
      default: true,
    },
    offsetX: {
      type: Boolean,
      default: false,
    },
    transition: {
      type: String,
      default: "scale-transition",
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "bluePrimary",
    },
    max: {
      type: String,
      default: null,
    },
    min: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    searchIcon: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    show: false,
  }),

  methods: {
    HandlerInputFtn(value) {
      this.$emit("input", value);
      this.show = false;
    },
    SearchFtn() {
      this.$emit("search");
    },
  },
};
</script>
